import { comics } from '@/mocks/data';
import StarRating from '@/components/base/StarRating';
import { useNavigate } from 'react-router-dom';

export default function HotRecommend() {
  const navigate = useNavigate();
  const hotComics = comics.slice(0, 5);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在看的精彩漫画</p>
          </div>
          <a
            href="/category"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <article
              key={comic.id}
              className="group cursor-pointer"
              onClick={() => navigate(`/article/${comic.id}`)}
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 古古漫画网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-full font-medium">
                    {comic.status}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h3>
              <StarRating rating={comic.rating} />
              <p className="text-xs text-foreground-500 mt-0.5">{comic.views} 阅读</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}